import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import WT1Report from './pages/WT1Report';
import WT2Report from './pages/WT2Report';
import WT3Report from './pages/WT3Report';
import WT4Report from './pages/WT4Report';
import About from './pages/About';
import WorkExperience from './pages/WorkExperience';
import Projects from './pages/Projects';
import Extracurriculars from './pages/Extracurriculars';
import Resume from './pages/Resume';

const App = () => {
  return (
    <div>
      <Header/>
      <Routes>
        <Route path="/wt4-report" element={<WT4Report />} />
        <Route path="/wt3-report" element={<WT3Report />} />
        <Route path="/wt2-report" element={<WT2Report />} />
        <Route path="/wt1-report" element={<WT1Report />} />
        <Route path="/" element={<About />} />
        <Route path="/work-experience" element={<WorkExperience />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/extracurriculars" element={<Extracurriculars />} />
        <Route path="/resume" element={<Resume/>} />
      </Routes>
      <Footer/>
    </div>
  );
};

export default App;